import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TimeService } from '../time.service';
import { DateTime } from 'luxon';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialog, NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { FavoriteLocationComponent } from '../favorite-location/favorite-location.component';
import { OrganisationNameComponent } from '../organisation-name/organisation-name.component';
import { AccessoriesComponent } from '../accessories/accessories.component';
import { PermitsComponent } from '../permits/permits.component';
import { LoadTypeComponent } from '../load-type/load-type.component';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { ValidationService } from '../validation.service';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { Router } from '@angular/router';
import { Messages } from '../constants/messages';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

declare var google: any;

export interface Locations {
  id: String;
  area: String;
}
export interface LocationWithTime {
  location: string;
  date: string;
}
export interface PostShipment {
  // ShipperId: String,
  organization: String;
  pickups: LocationWithTime[];
  deliveries: LocationWithTime[];
  materials: String[];
  vehicleType: String;
  permits: String[];
  accessories: String[];
  noOfVehicles: Number;
  weightPerVehicle: Number;
  payment_mode: string;
  comments: String;
}
export const PICK_FORMATS = {
  parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
  display: {
      dateInput: 'input',
      monthYearLabel: {year: 'numeric', month: 'short'},
      dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
      monthYearA11yLabel: {year: 'numeric', month: 'long'}
  }
};

export class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
      if (displayFormat === 'input') {
          return formatDate(date, 'dd-MMM-yyyy', this.locale);
      } else {
          return date.toDateString();
      }
  }
}
@Component({
  selector: 'app-post-shipment',
  templateUrl: './post-shipment.component.html',
  styleUrls: ['./post-shipment.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: PickDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS}
]
})
export class PostShipmentComponent implements OnInit {
  constructor(private timeService: TimeService, private dialog: MatDialog, private snackbar: SnackbarService,
              private http: HttpService, private valid: ValidationService, private events: EventService,
              private route: Router, private translation: TranslateService) { }
  pickupLocations = [];
  deliveryLocations = [];
  Organisations: any[];
  selectedOrganisation: any = {
    name: '',
    _id: ''
  };
  totalDistance = 0;
  optimizedDistance = 0;
  CarrierPrefs: any;
  optimize = false;
  map;
  mapMarkers = [];
  polyline;
  optimizedPolyline = [];
  geometry;
  weightPerVehicle = 0;
  noOfVehicles = 0;
  materialKey = '';
  permitKey = '';
  accKey = '';
  materials = [];
  permits = [];
  accessories = [];
  vehicles = [];
  show = false;
  confirm = false;
  vehicleKey: any = {};
  locSearchKey = '';
  dlocSearchKey = '';
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  pay: Boolean = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  pickupNo = 1;
  deliveryNo = 1;
  helpHeader = 'Header';
  helpContent = 'content to show for help text';
   carrierId: Subscription;
  modalScreens = [OrganisationNameComponent, FavoriteLocationComponent, AccessoriesComponent, PermitsComponent, LoadTypeComponent];
  messages = new Messages();
  helpData = [
    { head: 'Help', data: 'Choose the Pickup and Drop Locations and Timeline for the Shipment. Specify Vehicle Types and additional requirements for this Shipment.'},
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];;

  postShipmentData: PostShipment = {
    // ShipperId: '',
    organization: '',
    pickups: [],
    deliveries: [],
    materials: [],
    vehicleType: '',
    permits: [],
    accessories: [],
    noOfVehicles: 0,
    weightPerVehicle: 0,
    payment_mode: 'cash',
    comments: '',
  };
  picon = {
    url: 'assets/Pickup.svg'
};
dicon = {
  url: 'assets/Drop.svg'
};

  minDate: any = {
    pick: '',
    drop: ''
  };
  maxDate: any = {
    pick: '',
    drop: ''
  };
  vehicleKeyLength = 0;
  ngOnDestroy() {
    this.carrierId.unsubscribe();

  }
  ngOnInit() {
    this.getOrganisations();
    this.initMap();
    this.addLocation();
    this.addLocation('drop');
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrganisations();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }
  drop(event: CdkDragDrop<string[]>, drop= 'pickup') {
    moveItemInArray(drop == 'pickup' ? this.pickupLocations : this.deliveryLocations, event.previousIndex, event.currentIndex);
    this.placeAllFavMarkers();
  }
  check() {
    this.postShipmentData.payment_mode = this.pay ? 'cash' : 'pay_later';
  }
  openModal(component, heading = '') {
    const data: any = {
      organisation_id: this.selectedOrganisation._id
    };
    if (heading) {
      data.heading = heading;
    }
    const dialogRef = this.dialog.open(component, {
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.organisation) {
          this.Organisations.push(result.organisation.data);
          this.selectedOrganisation._id = this.Organisations[this.Organisations.length - 1]._id;
          this.selectedOrganisation.name = this.Organisations[this.Organisations.length - 1].name;
          // this.postShipmentData.organization = this.selectedOrganisation._id;
          this.getCarrierPrefs();

        } else if (result.location) {
          const location: any = result.location.data;
          if (result.type == 'Pickup Address') {
            if (!this.pickupLocations[this.pickupLocations.length - 1].loc_id ||
              this.pickupLocations[this.pickupLocations.length - 1].loc_id === '') {
              this.pickupLocations.splice(this.pickupLocations.length - 1, 1);
            }
            this.pickupLocations.push({
              area: location.area,
              name: location.name,
              latitude: location.latitude,
              longitude: location.longitude,
              loc_id: location._id
            });
            this.selectLocation(this.pickupLocations.length - 1, location);
          } else {
            if (!this.deliveryLocations[this.deliveryLocations.length - 1].loc_id ||
              this.deliveryLocations[this.deliveryLocations.length - 1].loc_id == '') {
              this.deliveryLocations.splice(this.deliveryLocations.length - 1, 1);
            }
            this.deliveryLocations.push({
              area: location.area,
              name: location.name,
              latitude: location.latitude,
              longitude: location.longitude,
              loc_id: location._id

            });
            this.selectLocation(this.deliveryLocations.length - 1, location, 'drop');
          }
          this.locSearchKey = '';
          this.dlocSearchKey = '';
          this.placeAllFavMarkers();
        } else if (result.material) {
          this.materials.push(result.material.data);
        } else if (result.permit) {
          this.permits.push(result.permit.data);
        } else if (result.accessory) {
          this.accessories.push(result.accessory.data);
        } else {

        }

        this.getCarrierPrefs();
      }
    });
  }
  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }
  getOrganisations() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.organizations.length) {
            this.Organisations = data.data.organizations;
            this.selectedOrganisation._id = this.Organisations[0]._id;
            this.selectedOrganisation.name = this.Organisations[0].name;
            // this.postShipmentData.organization = this.selectedOrganisation._id;
            this.getCarrierPrefs();
          }

          if (data.data.vehicle_types.length) {
            this.vehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  orgChange(value) {
    this.selectedOrganisation._id = value._id;
    this.selectedOrganisation.name = value.name;
    this.removeFocus();
    // this.postShipmentData.organization = value._id;
    this.getCarrierPrefs();
  }
  getCarrierPrefs() {
    this.http.get('org_pref?organization=' + this.selectedOrganisation._id).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.CarrierPrefs = data.data;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.statusCode == 401) {
          this.valid.logout();
        }
      }
    );

  }
  initMap(lat = 12.960691, lng = 77.580116) {
    let marker: any;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        marker = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.map.setCenter(marker);
      });
    }

    const mapProp = {
      center: marker || new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
    this.placeAllFavMarkers();
  }
  placePickupMarker(location, label= undefined) {
    if (location.latitude != '' && location.longitude != '') {
      const marker = new google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        map: this.map,
        icon: this.picon,
        label: {
          text: label || '',
          color: '#ffffff'
        }
      });

      this.mapMarkers.push(marker);
      marker.setMap(this.map);
    }
  }
  placeMarker(location, label = undefined) {
    if (location.latitude != '' && location.longitude != '') {
      const marker = new google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        map: this.map,
        icon: this.dicon,
        label: {
          text: label || '',
          color: '#ffffff'
        }
      });

      this.mapMarkers.push(marker);
      marker.setMap(this.map);
    }
  }
  optimizeRoute() {
    // Pickups
    if (this.optimizedPolyline.length) {
      this.optimizedPolyline.forEach(e => e.setMap(null));
      this.optimizedPolyline.length = 0;
    }

    let parr = this.pickupLocations.filter((p) => p.latitude != '');
    parr = parr.map((element: any) => {
        return { location: {lat: element.latitude, lng: element.longitude}};
    });

    let darr = this.deliveryLocations.filter((p) => p.latitude != '');
    darr = darr.map((element: any) => {
        return { location: { lat: element.latitude, lng: element.longitude}};
    });

    this.optimizedDistance = 0;

    darr.splice(0, 0, parr[parr.length - 1]);
    this.generateWayPoints(true, parr);
    this.generateWayPoints(true, darr);

  }
  placeAllFavMarkers() {
    this.removeAllMarkers();
    if (this.pickupLocations.length > 0) {
      this.pickupLocations.forEach((element, index) => {
        this.placePickupMarker(element, 'P' + (index + 1));
      });


    }
    if (this.deliveryLocations.length > 0) {
      this.deliveryLocations.forEach((element, index) => {
        this.placeMarker(element, 'D' + (index + 1));
      });
    }



    const locationCount = this.mapMarkers.length;
    if (this.polyline) {
      this.polyline.setMap(null); // Clear polyline
    }
    if (locationCount >= 2) {
      this.generateWayPoints();
      // this.calculateDistance();
    }
  }
  removeAllMarkers() {
    if (this.polyline) {
      this.polyline.setMap(null); // Clear polyline
    }
    this.mapMarkers.forEach(element => element.setMap(null));
    this.mapMarkers.length = 0;
  }
  generateWayPoints(optimize = false, locations = []) {

    const directionsService = new google.maps.DirectionsService;
    const directionsDisplay = new google.maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: optimize ? '#33AFE3' : '#7D7D7D',
        strokeOpacity: 1.0,
        strokeWeight: 6
      }
    });
    let wayPoints = [];

    if (!optimize) {
      this.mapMarkers.forEach(element => {
        wayPoints.push({ location: new google.maps.LatLng(element.getPosition().lat(), element.getPosition().lng()), stopover: true });
      });
    } else {
      wayPoints = locations;
    }
    const context = this;
    directionsDisplay.setMap(this.map);
    directionsDisplay.setOptions({ suppressMarkers: true });
    if (wayPoints.length) {
      directionsService.route({
        origin: wayPoints[0].location,
        destination: wayPoints[wayPoints.length - 1].location,
        waypoints: wayPoints,
        optimizeWaypoints: optimize,
        travelMode: 'DRIVING'
      }, function(response, status) {
        if (status === 'OK') {
          directionsDisplay.setDirections(response);
          if (optimize) {
            const arr = [];
            response.routes[0].waypoint_order.forEach(element => {
              arr.push({latitude: wayPoints[element].location.lat, longitude: wayPoints[element].location.lng});
            });
            context.optimizedPolyline.push(directionsDisplay);
            // context.calculateDistance(arr, [], 'bid')
            context.calculateDistanceFromWaypoints(response.routes[0].legs, 'bid');
          } else {
            context.polyline = directionsDisplay;
            context.calculateDistanceFromWaypoints(response.routes[0].legs);
          }
        }
      });

    }
  }

  calculateDistanceFromWaypoints(legs, type = 'normal') {
    let total = 0;
    legs.forEach(e => {
      total += parseFloat(e.distance.value);
    });
    total = total / 1000;
    if (type == 'normal') {
      this.totalDistance = total;
      total = 0;
    } else {
      this.optimizedDistance += total;
    }
  }
  setPickDateTime(index, value) {
    if (value.date && value.time) {
      const t1: any = this.timeService.getDateFromTime(value.time, 'hh:mm a');
      const t2: any = DateTime.fromJSDate(value.date).toFormat('dd/MM/yyyy');
      const epoch: any = DateTime.fromFormat(t2, 'dd/MM/yyyy').plus({hours: t1.c.hour, minutes: t1.c.minute});
      value.date_time = epoch.ts;
    }
  }
  selectLocation(index, location: any, type = 'pickup') {

    if (type === 'pickup') {
      this.pickupLocations[index].loc_id = location._id;
      this.pickupLocations[index].area = location.area;
      this.pickupLocations[index].name = location.name;
      this.pickupLocations[index].latitude = location.latitude;
      this.pickupLocations[index].longitude = location.longitude;
    } else {
      this.deliveryLocations[index].loc_id = location._id;
      this.deliveryLocations[index].area = location.area;
      this.deliveryLocations[index].name = location.name;
      this.deliveryLocations[index].latitude = location.latitude;
      this.deliveryLocations[index].longitude = location.longitude;
    }
    this.locSearchKey = '';
    this.dlocSearchKey = '';
    this.removeFocus();
    this.placeAllFavMarkers();
  }
  selectMaterial(material) {

    this.materials.push({
      _id: material._id,
      name: material.name
    });
    this.materialKey = '';
    this.removeFocus();
  }
  selectVehicle(vehicle) {
    // this.postShipmentData.vehicleType = vehicle._id;
    this.vehicleKeyLength = vehicle.name.length;
    this.vehicleKey._id = vehicle._id;
    this.vehicleKey.name = vehicle.name;
    this.removeFocus();
  }
  clearVehicle() {
    this.vehicleKey = {};
    this.vehicleKeyLength = 0;
  }
  selectPermits(permit) {
    this.permits.push({
      _id: permit._id,
      name: permit.name
    });
    this.permitKey = '';
    this.removeFocus();
  }
  selectAccessory(acc) {
    this.accessories.push({
      _id: acc._id,
      name: acc.name
    });
    this.accKey = '';
    this.removeFocus();
  }
  removeElement(index, type) {
    if (type == 'material') {
      this.materials.splice(index, 1);
    }
    if (type == 'permit') {
      this.permits.splice(index, 1);
    }
    if (type == 'accessories') {
      this.accessories.splice(index, 1);
    }
  }
  removeLocation(index, type= 'pickup') {
    if (type == 'pickup') {
      this.pickupLocations.splice(index, 1);
    } else {
      this.deliveryLocations.splice(index, 1);
    }
    this.placeAllFavMarkers();

  }
  addLocation(type= 'pickup') {
    this.minDate.pick = new Date();
    this.minDate.drop = new Date();

    if (type == 'pickup') {
      this.pickupLocations.push({
        area: '',
        name: '',
        latitude: '',
        longitude: '',
        date: (this.pickupLocations.length && this.pickupLocations[0].date) ? new Date(this.pickupLocations[0].date) : new Date(),
        time: this.timeService.fromJStoFormat(this.minDate.pick, 'hh:mm a'),
      });
    } else {
      this.deliveryLocations.push({
        area: '',
        name: '',
        latitude: '',
        longitude: '',
        date: (this.deliveryLocations.length && this.deliveryLocations[0].date) ? new Date(this.deliveryLocations[0].date) : new Date(),
        time: this.timeService.fromJStoFormat(this.minDate.drop, 'hh:mm a'),
      });

    }
  }

  postShipmentValidate() {
    let valid = true;
    this.postShipmentData.pickups = [];
    this.postShipmentData.deliveries = [];
    this.postShipmentData.materials = [];
    this.pickupLocations.forEach((ele, i) => {
      if (this.deliveryLocations) {
        if (this.deliveryLocations[0].date) {
          if (ele.date > this.deliveryLocations[0].date) {
            valid = false;
            this.snackbar.openSnackBar('P' + (i + 1) + this.translation.instant('MESSAGE.POST_SHIPMENT.VALIDATION.dateShouldBeLess'), '', 'err');
            return;
          }
        }
      }

    });
    const now: any = DateTime.local();
    this.pickupLocations.forEach((element, i) => {
      if (!element.loc_id) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.LOCATION_PICKUP + (i + 1), '', 'err');
      } else if (!element.date_time) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.CORRECT_DATE_TIME_PICKUP + (i + 1), '', 'err');
      } else if (element.date_time <= now) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.INVALID_DATE_TIME_PICKUP + (i + 1) , '', 'err');
      } else {
        const temp: any = {
          loc_id : element.loc_id,
          date_time: element.date_time
        };
        this.postShipmentData.pickups.push(temp);
      }
      if (!valid) {
        return valid;
      }
    });

    this.deliveryLocations.forEach((element, i) => {
      if (!element.loc_id) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.LOCATION_DELIVERY + (i + 1), '', 'err');
      } else if (!element.date_time) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.CORRECT_DATE_TIME_DELIVERY + (i + 1), '', 'err');
      } else if (element.date_time <= now) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.INVALID_DATE_TIME_DELIVERY + (i + 1), '', 'err');
      } else {
        const temp: any = {
          loc_id : element.loc_id,
          date_time: element.date_time
        };
        this.postShipmentData.deliveries.push(temp);
      }
      if (!valid) {
        return valid;
      }
    });

    if (this.materials.length <= 0) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.SELECT_MATERIAL, '', 'err');
    } else if (this.weightPerVehicle <= 0) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.WEIGHT, '', 'err');
    } else if (this.noOfVehicles <= 0) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.VALIDATION.NUMBER_VEHICLE, '', 'err');
    } else {
      this.postShipmentData.vehicleType = this.vehicleKey._id;
      this.postShipmentData.weightPerVehicle = this.weightPerVehicle;
      this.postShipmentData.noOfVehicles = this.noOfVehicles;
    }
    return valid;
  }
  postShipment() {


    if (this.postShipmentValidate()) {

      this.postShipmentData.organization = this.selectedOrganisation._id;
      this.postShipmentData.permits = this.permits.map((item) => item._id );
      this.postShipmentData.accessories = this.accessories.map((item) => item._id);
      this.postShipmentData.materials = this.materials.map((item) => item._id);
      console.log('dates -=-', this.postShipmentData);
      this.http.post('shipment/create', this.postShipmentData).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.snackbar.openSnackBar(this.messages.POST_SHIPMENT.SUCCESS.SHIPMENT, '');
            this.route.navigateByUrl('shipmentsDashboard');
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    }
  }
  clearAllFields() {
    this.postShipmentData = {
      // ShipperId: '',
      organization: '',
      pickups: [],
      deliveries: [],
      materials: [],
      vehicleType: '',
      permits: [],
      accessories: [],
      noOfVehicles: 0,
      weightPerVehicle: 0,
      payment_mode: 'cash',
      comments: '',
    };
    this.pickupLocations = [];
    this.deliveryLocations = [];

    this.vehicleKey = {};
    this.locSearchKey = '';
    this.weightPerVehicle = 0;
    this.noOfVehicles = 1;
    this.dlocSearchKey = '';
    this.materialKey = '';
    this.permitKey = '';
    this.accKey = '';
    this.materials = [];
    this.permits = [];
    this.accessories = [];
    this.addLocation();
    this.addLocation('drop');
    this.removeAllMarkers();
  }

}
